var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 252 252",
    width: "500px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.2,25.2) scale(0.8,0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,252v-252h252v252z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8e44ad"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.00656,10.08h-111.72656v231.84h181.44v-164.13469zM143.65969,177.01031h-74.95031l37.72125,-51.01031l37.22906,51.01031l-14.805,-20.41594l14.805,-20.39625l30.0825,40.81219zM168.97781,126c-5.27625,0 -9.54844,-4.15406 -9.54844,-9.27281c0,-5.11875 4.27219,-9.27281 9.54844,-9.27281c5.25656,0 9.54844,4.15406 9.54844,9.27281c0,5.11875 -4.29187,9.27281 -9.54844,9.27281zM146.16,80.64v-60.48l60.48,60.48z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.5f67b357165c9825229503af1da409e5.svg";
export { ForwardRef as ReactComponent };